import { queryOptions } from "@tanstack/react-query";
import { PageParams, Paginated, ShallowCourse } from "@vixi/types";
import { api, endpoints } from "@vixi/api";
import { COURSE_STATUS } from "@vixi/types";

/**
 * Query options to get the count of courses in review (waiting for publish).
 * Uses the getAllCourses endpoint with status filter set to WAITING_PUBLISH.
 *
 * @returns Query options that return the total count of courses in review
 */
export const inReviewCoursesCountQueryOptions = () =>
  queryOptions({
    queryKey: ["inReviewCoursesCount"],
    queryFn: async () => {
      const response = await api.get<Paginated<ShallowCourse>>(endpoints.getAllCourses, {
        params: {
          status: COURSE_STATUS.WAITING_PUBLISH,
          pageNumber: 1,
          pageSize: 1,
        } satisfies PageParams & { status: COURSE_STATUS },
      });

      return response.data.totalCount ?? 0;
    },
  });

